import React, { useEffect } from 'react'
import { HiOutlineUsers } from 'react-icons/hi2';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import PageTitle from '../../../../components/partials/PageTitle'
import { resetCustomerOverviewData } from '../../../../redux/slice/report/reportSlice';

const customerReports = [
    {name: 'Customer Overview',icon: <HiOutlineUsers size={26} />, link: '/admin/reports/customer-report/customer-overview', permission: 'customer overview report'},
    // {name: 'Claim History',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/customer-report/customer-overview'},
]
const CustomerReport = () => {
  const { user_permissions } = useSelector((state) => state?.auth?.user);

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const breadcrumb = {
        from: {
          title: "Reports",
          link: "/admin/reports",
        },
        current: {
          title: "Customer Report",
          link: null,
        },
      };

    useEffect(() => {
      dispatch(resetCustomerOverviewData())
    }, [dispatch])

    const filteredReports = customerReports.filter((item) => {
      return user_permissions?.some((permission) => permission.name === item.permission);
    });
    
    useEffect(() => {
      if (!user_permissions?.some(permission => permission.name === 'customer report module')) {
        navigate('/admin/dashboard')
      }
    }, [navigate, user_permissions])
  return (
    <>
        {/* page title */}
        <PageTitle title='Customer Report' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row gap-4 p-1 mt-2' style={{ margin: "auto 1px" }}>
            {filteredReports.map((item, i) => (
                <Link to={item?.link} className='col-3 card p-3 hover-primary' key={i}>
                    <div className=' d-flex gap-2 flex-column  align-items-center'>
                        <div>
                            <span className='icon-primary'>{item?.icon}</span>
                        </div>
                        <div>
                            <p>{item?.name}</p>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    </>
  )
}

export default CustomerReport